<template>
  <ComponentLayout
    id="add-additional-field"
    class="add-additional-field">
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0"
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <div class="h2-headline text-start mt-5 mb-8 width-100">
        {{ $t('AdditionalFields.AdditionalField') }}
      </div>
      <div class="add-additional-field__content-card main__light_green rounded-lg px-14 py-10">
        <sAlert
          v-if="entitiesCount"
          class="mb-4"
          small>
          {{ $t('Validate.FieldAlreadyBinded') }}
        </sAlert>
        <sForm
          ref="addAdditionalFieldForm"
          class="flex flex-wrap flex-direction-column"
          label-position="top"
          label-width="100px"
          :model="formData"
          :rules="rules"
          style="width: 400px;">
          <sFormItem
            class="add-additional-field__name mb-5"
            :label="$t('AdditionalFields.FieldName')"
            prop="name">
            <sInput
              class=" width-100"
              clearable
              data-qa="add-additional-field__name"
              :disabled="loading"
              :max-length="4000"
              max-rows="5"
              :placeholder="$t('Common.EnterName')"
              rows="1"
              type="textarea"
              :value.sync="formData.name"/>
          </sFormItem>
          <sFormItem
            class="mb-5"
            :label="$t('AdditionalFields.FieldType')"
            prop="type.typeId">
            <sSelect
              class=" width-100"
              data-qa="add-additional-field__type"
              :disabled="entitiesCount !==0 || existLink || loading || load_types"
              :loading="loading || load_types"
              :placeholder="$t('AdditionalFields.FieldType')"
              popper-class="add-additional-field__select-type "
              :tag-label="$t('Common.Selected')"
              :value.sync="formData.type"
              value-key="typeId"
              @update:value="changeType">
              <sOption
                v-for="item_type in additional_types"
                :key="`item-${item_type.typeId}`"
                class="px-4"
                :data-qa="`item-${item_type.typeId}`"
                :disabled="loading || load_types"
                :label="item_type.name"
                :value="item_type">
                <sIcon
                  class="my-auto mr-2"
                  :type="item_type.icon"/>
                {{ item_type.name }}
              </sOption>
            </sSelect>
            <sProgress
              v-if="load_types"
              class="ml-4 width-90 mb-0"
              indeterminate
              :stroke-width="2"
              style="position: relative; top: -3px;"/>
          </sFormItem>

          <sFormItem
            v-if="formData.type.typeId == 'DECIMAL' && formData.options"
            class="add-additional-field__name mb-5"
            :label="$t('Common.Decimals')"
            prop="decimals">
            <sInputNumber
              class="width-100"
              clearable
              data-qa="add-additional-field__name"
              :disabled="loading || existLink"
              :max="5"
              :min="0"
              :placeholder="$t('Common.Decimals')"
              :precision="0"
              :value.sync="formData.decimals"/>
          </sFormItem>

          <div
            v-if="formData.type.typeId == 'DROPDOWN' && formData.options"
            class="add-additional-field__options flex flex-direction-column align-start mb-5">
            <div class="h7-text mb-4">
              {{ $t('AdditionalFields.OptionsList') }}
            </div>
            <sFormItem
              v-for="(option, index) in formData.options"
              :key="index"
              class="width-100"
              :label="$t('AdditionalFields.Option') + ' ' + (index + 1)"
              :prop="`options[${index}].value`">
              <div
                class="flex no-wrap">
                <sInput
                  class="width-100"
                  clearable
                  data-qa="add-additional-field__option"
                  :disabled="loading"
                  :max-length="4000"
                  max-rows="2"
                  :placeholder="$t('Common.EnterName')"
                  rows="1"
                  type="textarea"
                  :value.sync="formData.options[index].value"/>
                <sButton
                  v-if="formData.options.length > 2"
                  class="add-additional-field__delete-option mr-4 my-auto"
                  data-qa="delete-option"
                  :disabled="loading"
                  icon="delete"
                  small
                  type="text"
                  @click="$_deleteOption(index, formData.options)"/>
              </div>
            </sFormItem>

            <sButton
              v-if="formData.options.length"
              class="add-additional-field__add-option px-2 h10-links "
              data-qa="btn-add-option"
              :disabled="loading"
              icon="plus"
              icon-size="8px"
              small
              type="text"
              @click="$_addAOption(formData.options, rules)">
              {{ $t('AdditionalFields.AddOption') }}
            </sButton>
          </div>

          <sFormItem
            v-if="formData.options.length"
            class="add-additional-field__mannager_editing mannager_editing mb-5"
            prop="mannager_editing">
            <template #label>
              <div class="mannager_editing__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.AllowManagersEditList') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.mannager_editing"
              class="mannager_editing__group  width-100 "
              data-qa="mannager_editing-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'mannager_editing-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>

          <sFormItem
            class="add-additional-field__attach_to attach_to mb-5"
            prop="attach_to">
            <template #label>
              <div class="attach_to__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.PleaseIndicateAttachTo') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.attach_to"
              class="attach_to__group  width-100 "
              data-qa="attach_to-group"
              :disabled="entitiesCount !==0 || existLink || loading"
              row>
              <sRadio
                v-for="item in binding_levels"
                :key="item.value"
                :data-qa="'binding_levels-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>

          <sFormItem
            class="add-additional-field__Link_to_category link_to_category mb-5"
            prop="link_to_category">
            <template #label>
              <div class="link_to_category__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.LinkFieldToCategory') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.link_to_category"
              class="link_to_category__group  width-100 "
              data-qa="link_to_category-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'link_to_category-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>

          <sFormItem
            v-if="formData.link_to_category"
            ref="field-category"
            class="mb-5 d-flrx flrx-column input"
            :label="$t('Tenders.Category')"
            prop="categorys">
            <template #default="{ state }">
              <CategoryDropdownTree
                class="add-additional-field__choose-category category"
                data-qa="use-categorys"
                :disabled="loading"
                input-type="textarea"
                :label="$t('Tenders.Category')"
                :max-multiple-count="null"
                :model.sync="formData.categorys"
                multiple
                @clear="formData.categorys=[]">
                <template #activator="{items, open }">
                  <div
                    slot="activator"
                    class="category-block"
                    :class="{'exist-item': items.length, 'border-error': state === 'error'}"
                    @click="open">
                    <div
                      v-for="category in items"
                      :key="category.classificationCode"
                      class="category-block__item">
                      {{ category.title }}
                    </div>
                  </div>
                </template>
              </CategoryDropdownTree>
            </template>
          </sFormItem>

          <sFormItem
            class="add-additional-field__Link_to_bidType link_to_bidType mb-5"
            prop="link_to_bidType">
            <template #label>
              <div class="link_to_bidType__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.LinkFieldToBidType') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.link_to_bidType"
              class="link_to_bidType__group  width-100 "
              data-qa="link_to_bidType-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'link_to_bidType-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>

          <sFormItem
            v-if="formData.link_to_bidType"
            ref="field-type"
            class="mb-5"
            :label="$t('Tenders.TenderType')"
            prop="bidTypes">
            <sSelect
              class=" width-100 add-additional-field__choose-type input"
              clearable
              data-qa="biddingType"
              :disabled="loading || load_bid_types"
              filterable
              :loading="loading || load_bid_types"
              multiple
              :placeholder="$t('Tenders.TenderType')"
              :tag-label="$t('Common.Selected')"
              :value.sync="formData.bidTypes"
              value-key="biddingTypeId">
              <sOption
                v-for="item in bidding_types"
                :key="`bidding-types-${item.biddingTypeId}`"
                :data-qa="`biddingType-item-${item.biddingTypeId}`"
                :label="item.titleRu"
                :value="item"/>
            </sSelect>
            <sProgress
              v-if="load_bid_types"
              class="ml-4 width-90 mb-0"
              indeterminate
              :stroke-width="2"
              style="position: relative; top: -3px;"/>
          </sFormItem>

          <sFormItem
            class="add-additional-field__required required mb-5"
            prop="required">
            <template #label>
              <div class="required pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.RequiredField') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.required"
              class="required  width-100 "
              data-qa="required-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'required-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>

          <sFormItem
            class="add-additional-field__show_to_perticipant show_to_perticipant mb-5"
            prop="show_to_perticipant">
            <template #label>
              <div class="show_to_perticipant__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.ShowParticipantsOnTheSite') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.show_to_perticipant"
              class="show_to_perticipant__group  width-100 "
              data-qa="show_to_perticipant-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'show_to_perticipant-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>


          <sFormItem
            v-if="showAsSpecialFieldAvailable"
            class="mb-5"
            prop="showAsSpecialField">
            <template #label>
              <div class="pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.ShowAsSpecialField') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.showAsSpecialField"
              class="width-100 "
              data-qa="show_as_special_field-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'show_as_special_field-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>


          <sFormItem
            v-if="itemId"
            class="mb-5"
            prop="active">
            <template #label>
              <div class="pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.ActiveField') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.active"
              class="width-100 "
              data-qa="active-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="item in $_options_yes_or_no"
                :key="item.value"
                :data-qa="'active-' + item.value"
                :label="item.value">
                {{ item.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>
        </sForm>
      </div>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer"
        :back="close"
        :back_btn="$t('Common.Cancel')"
        :next="apply"
        :next_btn="itemId ? $t('Common.Save') : $t('AdditionalFields.Create')"/>
    </template>
  </ComponentLayout>
</template>

<script>
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import CategoryDropdownTree from 'components/common/dialogs/CategoryDropDownTree.vue'

import { additionalFieldsMixin } from 'mixins'
import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const api = new AdditionalFieldsApi()
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

export default {
  name: 'addAdditionalField',
  mixins: [additionalFieldsMixin],
  data: that => ({
    formData: {
      name: '',
      type: {},
      active: true,
      options: [],
      show_to_perticipant: true,
      attach_to: 'TENDER',
      link_to_category: true,
      categorys: [],
      link_to_bidType: true,
      bidTypes: [],
      required: true,
      mannager_editing: false,
      decimals: '0',
      showAsSpecialField: false
    },
    entitiesCount: 0,
    existLink: false,
    bidding_types: [],
    loading: false,
    load_types: false,
    load_bid_types: false,
    rules: {
      name: [
        {
          type: 'string',
          trigger: 'change',
          transform(value) {
            return value.trim()
          },
          required: true,
          min: 2,
          message: that.$t('Validate.minLength', {number: 2, type: that.$tc('Common.characters', 2) })
        },
        {
          type: 'string',
          required: true,
          trigger: 'change',
          max: 256,
          message: that.$t('Validate.maxLength', {number: 256, type: that.$tc('Common.characters', 10) })
        }
      ],
      'type.typeId': {
        trigger: 'change',
        required: true,
        message: that.$t('Validate.MustBeAdded')
      },
      categorys: {
        trigger: 'change',
        required: true,
        validator(rule, value, callback) {
          if (that.formData.link_to_category && (!value || !value?.length)) {
            callback(new Error(that.$t('Validate.MustBeAdded')))
          }
          callback()
        },
      },
      bidTypes: {
        trigger: 'change',
        required: true,
        validator(rule, value, callback) {
          if (that.formData.link_to_bidType && (!value || !value?.length)) {
            callback(new Error(that.$t('Validate.MustBeAdded')))
          }
          callback()
        },
      },
    },
    breadcrumbs: [
      {
        text: that.$t('Menu.AdditionalFieldsConstructor'),
        to: {name: 'additionalFieldsConstructor'}
      },
      {
        text: that.$t('AdditionalFields.CreateNew') ,
      },
    ],
    binding_levels: [
      { label: that.$t('Tenders.ToTender'), value: 'TENDER'},
      { label: that.$t('Tenders.ToLot'), value: 'LOT'},
    ],
  }),
  async created() {
    this.$log( this.itemId )
    this.load_bid_types = true
    this.load_types = true
    const types = this.$store.dispatch('setAdditionalFieldsTypes')
    //.finally(() => this.load_types = false)

    const bidTypes = this.$store.dispatch('setBiddingTypes')
    /*.then(res => this.bidding_types = res)
      .finally(() => this.load_bid_types = false)*/

    Promise.all([types, bidTypes]).then((result) => {
      this.bidding_types = result[1]
      this.load_types = false
      this.load_bid_types = false
      if ( this.itemId ) {
        this.loading = true
        api.getAdditionalField(this.itemId)
          .then(res => {
            if (res.id) {

              let classificationCodes = []
              res.bindingCondition?.classificationCodes.forEach((item) => {
                classificationCodes = classificationCodes.concat(item)
              })
              classificationCodes = classificationCodes.filter(i => i)

              tender_api.subcategories(classificationCodes).then(classifications => {
                const biddingTypeIds = res.bindingCondition?.biddingTypeIds.filter(i => i) || []

                this.entitiesCount = res.entitiesCount
                this.formData = {
                  name: res.caption,
                  active: res.active,
                  type: { typeId: res.typeId },
                  options: res.settingValues.filter(opt => opt.settingType == 'SELECT_OPTION').map(opt => ({value: opt.value, id: opt.id})),
                  show_to_perticipant: res.showForBidders,
                  showAsSpecialField: res.showAsSpecialField,
                  attach_to: res.bindingLevel,
                  link_to_category: !!classificationCodes?.length || false,
                  categorys: classifications,
                  link_to_bidType: !!biddingTypeIds?.length || false,
                  bidTypes: biddingTypeIds ? this.bidding_types?.filter(i => biddingTypeIds.includes(i.biddingTypeId)) : [],
                  required: res.settingValues.some(set => set.settingType == 'REQUIRED' && eval(set.value)),
                  mannager_editing: res.settingValues.some(set => set.settingType == 'ALLOW_CHANGE_SELECT_OPTIONS' && eval(set.value)),
                  decimals: res.settingValues.
                    find(set => set.settingType == 'DECIMALS' && set.value?.length)?.
                    value || '0'
                }

                this.existLink = !!classificationCodes?.length || !!biddingTypeIds?.biddingTypeId
              })
            }
          })
          .finally(() => this.loading = false )


      }
    })

  },
  computed: {
    itemId() {
      return this.$route.params?.id
    },
    showAsSpecialFieldAvailable() {
      return this.formData.type?.typeId === 'DECIMAL' && this.formData.attach_to == 'LOT'
    }
  },
  watch: {
    showAsSpecialFieldAvailable(value) {
      if (!value) {
        this.formData.showAsSpecialField = false
      }
    }
  },
  methods: {
    changeType(type) {
      this.$_changeFieldType(type, this.formData.options, this.rules)
    },
    close() {
      this.$router.push({name: 'additionalFieldsConstructor'})
    },
    async apply() {
      await this.$refs.addAdditionalFieldForm.validate().catch(er => {
        this.$notice.info({
          title: this.$t('Common.PleaseNote'),
          message: this.$t('Validate.checkRequiredFelds'),
          showClose: true,
          progress: true,
          duration: 10
        })
        throw er
      })
      this.loading = true
      try {
        let biddingTypeIds = this.formData.link_to_bidType ? this.formData.bidTypes.map(i => i.biddingTypeId) : []
        let classificationCodes = this.formData.link_to_category ? this.formData.categorys.map(i => i.classificationCode) : []
        let model = {
            id: this.itemId  || '00000000-0000-0000-0000-000000000000',
            typeId: this.formData.type.typeId,
            active: this.formData.active,
            caption: this.formData.name,
            showForBidders: this.formData.show_to_perticipant,
            showAsSpecialField: this.formData.showAsSpecialField,
            defaultValue: null,
            bindingLevel: this.formData.attach_to,
            bindingCondition: {
              biddingTypeIds: biddingTypeIds,
              classificationCodes: classificationCodes
            },
            settingValues: this.formData.options.map(opt => ({
              id: opt.id,
              value: opt.value,
              settingType: 'SELECT_OPTION'
            })).concat([
              {
                value: this.formData.required + '',
                settingType: 'REQUIRED'
              },
              {
                value: this.formData.mannager_editing + '',
                settingType: 'ALLOW_CHANGE_SELECT_OPTIONS'
              }
            ]),
          }, request = ''

        if (this.formData.decimals) {
          model.settingValues.push(
            {
              value: this.formData.decimals + '',
              settingType: 'DECIMALS'
            })
        }

        if ( this.itemId ) {
          request = 'updateAdditionalField'
        } else {
          request = 'createAdditionalField'
        }

        await api[request](model)
          .then(this.close)
      } catch (error ) {
        this.$notice.error({
          title: this.$t('Common.ErrorTitle'),
          message: error?.message || error,
          duration: 10,
        })
        this.$log_error( error )
        throw error
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Breadcrumbs,
    ComponentFooter,
    ComponentLayout,
    CategoryDropdownTree
  }
}
</script>
<style lang="scss" scoped>
.add-additional-field__content-card {
  overflow: auto;
  width: 100%;
}
.category-block {
  border: 2px solid var(--color-main-green);
  background: var(--white-color);
  border-radius: 31px;
  padding: 10px;
  min-height: 40px;
  cursor: pointer;
  max-height: 200px;
  overflow: auto;
  &__item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  &.exist-item {
    border-radius: 15px;
  }
  &.border-error {
    border-color: var(--color-error);
  }
}
</style>
